import { render, staticRenderFns } from "./ActivityShimmer.vue?vue&type=template&id=d3be49c0&"
import script from "./ActivityShimmer.vue?vue&type=script&lang=js&"
export * from "./ActivityShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports